import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import InView from "react-intersection-observer";
import { motion } from "framer-motion";
export default function SingleGalleryImg({ image }) {
  return (
    <InView threshold={0.25}>
      {({ ref, inView }) => (
        <motion.div
          ref={ref}
          initial={{ y: 20, opacity: 0 }}
          animate={inView ? { y: 0, opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.8 }}
          className="img"
        >
          <LazyLoadImage
            src={image.photo}
            draggable="false"
            effect="blur"
            alt={"image of " + image.desc}
            onContextMenu={(e) => e.preventDefault()}
          />
          <p>{image.desc}</p>
        </motion.div>
      )}
    </InView>
  );
}
